export enum EnRequestType {
    Post,
    Get,
    Delete,
    Patch,
    Put
}
